import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { NgClass } from '@angular/common';
import { SuiTooltipDirective } from '@sui/tooltip';

@Component({
  selector: 'app-company-badge',
  templateUrl: './company-badge.component.html',
  styleUrl: './company-badge.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgClass, SuiTooltipDirective],
})
export class CompanyBadgeComponent {
  @Input() companyName: string = '';
  @Input() isSwitcher: boolean = false;
  @Input() isDropDownItem: boolean = false;

  // This method generates initials from the company name
  // It takes the first letter of the first word and the first letter of the last word
  // and returns them in uppercase.
  // If the company name is a single word, it returns the first letter in uppercase.
  // If the company name is empty, it returns an empty string.
  constructor() {}

  initials: string = '';

  ngOnInit(): void {
    if (!this.companyName) {
      console.warn('CompanyBadgeComponent: companyName is not provided');
    }
    this.initials = this.getInitials(this.companyName);
  }

  ngOnChanges(): void {
    this.initials = this.getInitials(this.companyName);
  }

  getInitials(companyName: string): string {
    if (!companyName) return '';

    const words = companyName.trim().split(/\s+/);

    // Normalize first word
    const firstWord = words[0];

    // If single word, return first 2 letters
    if (words.length === 1) {
      return firstWord.substring(0, 2).toLocaleUpperCase();
    }

    // Multiple words: Get first letter of first word
    const firstLetter = firstWord.charAt(0).toLocaleUpperCase();

    // Find last valid word starting with a letter (Unicode-aware)
    let lastLetter = '';
    for (let i = words.length - 1; i >= 1; i--) {
      if (/^\p{L}/u.test(words[i])) {
        lastLetter = words[i].charAt(0).toLocaleUpperCase();
        break;
      }
    }

    // Return initials
    return lastLetter ? firstLetter + lastLetter : firstLetter;
  }
}
